import { createAsyncThunk } from "@reduxjs/toolkit";
import { ICategoryRequestView } from "../../modules/categories/models/ICategoryRequestView";
import { CategoryService } from "../../modules/categories/services/categoryService";
import { ICategoryResponseView } from "../../modules/categories/models/ICategoryResponseView";
import { AuthUtil } from "../../utils/AuthUtil";

/**
 * Create a Category
 */
export const createCategoryAction: any = createAsyncThunk(
  "categories/createCategoryAction",
  async (
    payload: { category: ICategoryRequestView },
    { rejectWithValue }
  ): Promise<
    { data: ICategoryResponseView; msg: string; status: string } | any
  > => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { category } = payload;
        const response = await CategoryService.createCategory(category);
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Create a Sub Category
 */
export const createSubCategoryAction: any = createAsyncThunk(
  "categories/createSubCategoryAction",
  async (
    payload: { category: ICategoryRequestView; categoryId: string },
    { rejectWithValue }
  ): Promise<
    { data: ICategoryResponseView; msg: string; status: string } | any
  > => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { category, categoryId } = payload;
        const response = await CategoryService.createSubCategory(
          category,
          categoryId
        );
        return response.data;
      }
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get All Categories
 */
export const getAllCategoriesAction: any = createAsyncThunk(
  "categories/getAllCategoriesAction",
  async (
    payload: {},
    { rejectWithValue }
  ): Promise<
    { data: ICategoryResponseView[]; msg: string; status: string } | any
  > => {
    try {
      const response = await CategoryService.getAllCategories();
      return response.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
